// @ts-nocheck
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import paths from 'paths';

const RootRedirect = () => {
    const navigate = useNavigate();
    const organisations = useSelector(state => state.auth.user?.organisations || []);

    useEffect(() => {
        if (organisations.length === 0) {
            navigate(paths.start.getPath(), { replace: true });
        } else {
            navigate(paths.penlyAccess.getPath(organisations[0].organisationId), { replace: true });
        }
    }, [navigate, organisations]);

    return null;
};

export default RootRedirect;
